<template>
  <j-modal :width="modalWidth" :visible="visible" :title="title" switchFullscreen wrapClassName="j-user-select-modal"
    @ok="handleSubmit" @cancel="close" style="top: 50px" :cancelText="$store.getters.language['common.closeButton']">
    <a-row :gutter="10" style="background-color: #ececec; padding: 10px; margin: -10px">
      <a-col :md="6" :sm="24">
        <a-card :bordered="false">
          <!--组织机构-->
          <a-directory-tree selectable :selectedKeys="selectedDepIds" :checkStrictly="true"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }" :treeData="departTree" :expandAction="false"
            :expandedKeys.sync="expandedKeys" @select="onDepSelect" />
        </a-card>
      </a-col>
      <a-col :md="18" :sm="24">
        <a-card :bordered="false">
          <!-- 用户账号: -->
          {{ $store.getters.language['fd.Basic.FmUserRightsList.yonghuzhanghao'] }}:
          <a-input-search :style="{ width: '150px', marginBottom: '15px' }" :placeholder="$store.getters.language['fd.basic.pleaseinputaccount']"
            v-model="queryParam.username" @search="onSearch"></a-input-search>
          <a-button @click="searchReset(1)" style="margin-left: 20px" icon="redo">{{$store.getters.language['common.resetButton']}}</a-button>
          <!--用户列表-->
          <a-table ref="table" :scroll="scrollTrigger" size="middle" rowKey="id" :columns="columns"
            :dataSource="dataSource" :pagination="ipagination"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: getType }"
            :loading="loading" @change="handleTableChange">
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </j-modal>
</template>

<script>
import { pushIfNotExist, filterObj } from '@/utils/util'
import { queryDepartTreeList, getUserList, queryUserByDepId } from '@/api/api'
import { getAction } from '@/api/manage'

export default {
  name: 'JSelectUserByDepAndApplicationModal',
  components: {},
  props: ['modalWidth', 'multi', 'userIds', 'store', 'text', 'applicationCode', 'factory'],
  data() {
    return {
      queryParam: {
        username: '',
      },
      columns: [
        {
          title: this.$store.getters.language['user.column.userName'],// '用户账号',
          align: 'center',
          dataIndex: 'username',
        },
        {
          title:this.$store.getters.language['user.column.realname'],// '用户姓名',
          align: 'center',
          dataIndex: 'realname',
        },
        {
          title: this.$store.getters.language['user.column.sex'],//'性别',
          align: 'center',
          dataIndex: 'sex',
          customRender: function (text) {
            if (text === 1) {
              return this.$store.getters.language['common.sex.man'] //'男'
            } else if (text === 2) {
              return this.$store.getters.language['common.sex.woman'] //'女'
            } else {
              return text
            }
          },
        },
        {
          title: this.$store.getters.language['fd_lostftype.LF04'],//'手机',
          align: 'center',
          dataIndex: 'phone',
        },
        {
          title: this.$store.getters.language['portal.personalOrgCode'],//'部门',
          align: 'center',
          dataIndex: 'orgCodeTxt',
        },
      ],
      scrollTrigger: {},
      dataSource: [],
      selectionRows: [],
      selectedRowKeys: [],
      selectUserRows: [],
      selectUserIds: [],
      title: this.$store.getters.language['fd.selectUserByDepart'], // '根据部门选择用户',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + this.$store.getters.language['page.total'] + total + this.$store.getters.language['page.article']
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      selectedDepIds: [],
      departTree: [],
      visible: false,
      form: this.$form.createForm(this),
      loading: false,
      expandedKeys: [],
    }
  },
  computed: {
    // 计算属性的 getter
    getType: function () {
      return this.multi == true ? 'checkbox' : 'radio'
    },
  },
  watch: {
    userIds: {
      immediate: true,
      handler() {
        this.initUserNames()
      },
    },
  },
  created() {
    // 该方法触发屏幕自适应
    this.resetScreenSize()
    //this.loadData()
  },
  methods: {
    initUserNames() {
      if (this.userIds) {
        // 这里最后加一个 , 的原因是因为无论如何都要使用 in 查询，防止后台进行了模糊匹配，导致查询结果不准确
        let values = this.userIds.split(',') + ','
        let param = { [this.store]: values }
        getAction('/sys/user/getMultiUser', param).then((list) => {
          this.selectionRows = []
          let selectedRowKeys = []
          let textArray = []
          if (list && list.length > 0) {
            for (let user of list) {
              textArray.push(user[this.text])
              selectedRowKeys.push(user['id'])
              this.selectionRows.push(user)
            }
          }
          this.selectedRowKeys = selectedRowKeys
          this.$emit('initComp', textArray.join(','))
        })
      } else {
        // JSelectUserByDep组件bug issues/I16634
        this.$emit('initComp', '')
        // 前端用户选择单选无法置空的问题 #2610
        this.selectedRowKeys = []
      }
    },
    async loadData(arg) {
      if (arg === 1) {
        this.ipagination.current = 1
      }
      let params = this.getQueryParams() //查询条件
      this.loading = true
      getAction('/sys/user/queryUserComponentData', params)
        .then((res) => {
          if (res.success) {
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 触发屏幕自适应
    resetScreenSize() {
      let screenWidth = document.body.clientWidth
      if (screenWidth < 500) {
        this.scrollTrigger = { x: 800 }
      } else {
        this.scrollTrigger = {}
      }
    },
    showModal() {
      this.visible = true
      this.queryDepartTree()
      this.initUserNames()
      // this.loadData();
      this.form.resetFields()
    },
    getQueryParams() {
      console.log('JSelectUserByDepAndApplicationModal.vue')
      let param = Object.assign({}, this.queryParam, this.isorter)
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      param.departId =  this.selectedDepIds.join(',')
      return filterObj(param)
    },
    processRoot() {
      if (this.departTree.length) {
        if (this.selectedDepIds.length == 1) {
          let selectedId = this.selectedDepIds[0]
          if (this.departTree[0].id == selectedId && this.departTree[0].children.length) {
            return this.departTree[0].children.map(w => w.id).join()
          }
        }
      }
      return this.selectedDepIds.join(',')
    },
    getQueryField() {
      let str = 'id,'
      for (let a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex
      }
      return str
    },
    searchReset(num) {
      let that = this
      that.selectedRowKeys = []
      that.selectUserIds = []
      //that.selectedDepIds = []
      if (num !== 0) {
        that.queryParam = {}
        that.loadData(1)
      }
    },
    close() {
      this.searchReset(0)
      this.visible = false
    },
    handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' === sorter.order ? 'asc' : 'desc'
      }
      this.ipagination = pagination
      this.loadData()
    },
    handleSubmit() {
      let that = this
      this.getSelectUserRows()
      that.$emit('ok', that.selectUserRows)
      that.searchReset(0)
      that.close()
    },
    //获取选择用户信息
    getSelectUserRows() {
      this.selectUserRows = []
      for (let row of this.selectionRows) {
        if (this.selectedRowKeys.includes(row.id)) {
          this.selectUserRows.push(row)
        }
      }
      this.selectUserIds = this.selectUserRows.map((row) => row.username).join(',')
    },
    // 点击树节点,筛选出对应的用户
    onDepSelect(deptIds) {
      if (deptIds && deptIds[0]) {
        if (this.selectedDepIds[0] !== deptIds[0]) {
          this.selectedDepIds = [deptIds[0]]
        }
        this.loadData(1)
      }
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      selectionRows.forEach((row) => pushIfNotExist(this.selectionRows, row, 'id'))
    },
    onSearch() {
      this.loadData(1)
    },
    // 根据选择的id来查询用户信息
    initQueryUserByDepId(deptIds) {
      this.loading = true
      return queryUserByDepId({ id: deptIds.toString() })
        .then((res) => {
          if (res.success) {
            this.dataSource = res.result
            this.ipagination.total = res.result.length
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    filterTreeDataByFactory(treeData) {
      if (treeData.length) {
        var items = []
        var factoryList = (this.factory || '').split(',')
        for (let i = 0; i < treeData.length; i++) {
          var node = { ...treeData[i], selectable: false }
          if (node.children) {
            node.children = node.children.filter(w => w.levelNo != '13' || (factoryList.includes(w.thirdOrgCode)))
          }
          items.push(node)
        }
        return items
      }
      return []
    },
    queryDepartTree() {
      let params = {}
      if (this.applicationCode) {
        params.applicationCode = this.applicationCode
      }
      queryDepartTreeList(params).then((res) => {
        if (res.success) {
          this.departTree = res.result
          this.departTree = this.filterTreeDataByFactory(this.departTree)
          if (this.departTree && this.departTree.length) {
            if (this.departTree[0].children.length) {
              this.selectedDepIds = [this.departTree[0].children[0].id]
            }
            this.loadData(1)
          }
          // 默认展开父节点
          this.expandedKeys = this.departTree.map((item) => item.id)
        }
      })
    },
    modalFormOk() {
      this.loadData()
    },
  },
}
</script>

<style scoped>
.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
</style>